// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"070f4902","239":"51b4f0ea","455":"452ffff4","581":"16106015"}[chunkId] + ".chunk.js";
};